export const resetFileInput = (file, text) => {
  document.getElementById(file).value = "";
  document.getElementById(text).value = "";
};
